/*eslint-disable */
import {bus} from '@/main';
import groupCreatePopup from '../popup/group-create-popup/';
export default {
  name: 'chat-list-sidebar',
  components: {
    'create-group-popup' : groupCreatePopup
  },
  props: [],
  data () {
    return {
      createGroupPopupState:false,
      isMobile:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('createGroupPopupBus', (data) => {
        this.createGroupPopupState = data
    })
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    createGroupPopupMethod(){
      this.createGroupPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    }
  }
}


